import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import type { HydrateAction } from 'redux-store';

import type { NotificationProps, InitialStateType } from './types';

const initialState: InitialStateType = {
  hash: {},
};

let counter = 1;

export const NotificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    add(
      state,
      {
        payload,
      }: PayloadAction<
        Omit<NotificationProps, 'id'> & Partial<Pick<NotificationProps, 'id'>>
      >,
    ) {
      const id = payload.id || counter++;
      const item = { ...payload, id };

      state.hash[id] = item;

      return state;
    },
    close(state, { payload }: PayloadAction<Pick<NotificationProps, 'id'>>) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete state.hash[payload.id];

      return state;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      HYDRATE,
      (state, action: HydrateAction<InitialStateType>) => {
        return action.payload.notifications;
      },
    );
  },
});
